import React, {useEffect, useState} from "react";
import {Fade, Tooltip} from "@mui/material";
import Box from "@mui/material/Box";

export default function WeaponIcon(props: { weapon: string; width: number; height: number; reverse?: boolean, rotate?: boolean }) {
    const [src, setSrc] = useState(
        `https://res.cloudinary.com/xenesis/image/upload/c_limit,w_${props.width},h_${props.height}/valAssets/${props.weapon}.png`
    );

    const handleImageError = () => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_limit,w_${props.width},h_${props.height}/teamsLogo/Please Dont Fire.png`); // Replace with the path to your placeholder image
    };

    useEffect(() => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_limit,w_${props.width},h_${props.height}/valAssets/${props.weapon}.png`);
    }, [props.weapon, props.width, props.height]);

    return (
        <Tooltip title={props.weapon} followCursor={true}>
            <Fade in={true} timeout={300}>
            <Box
                component={"img"}
                src={src}
                onError={handleImageError}
                sx={{
                    display: "block",
                    maxWidth: props.width,
                    maxHeight: props.height,
                    objectFit: "contain",
                    transform: `${props.reverse ? "scaleX(-1)" : ""} ${props.rotate ? "rotate(15deg)" : ""}`, // Flip the image horizontally if reverse is true
                    transition: "transform 0.2s ease-in-out", // Optional: smooth animation when reverse changes
                }}
            />
            </Fade>
        </Tooltip>
    );
}